$shm_hitalama_docs $shm_hitalama_textbook
	menu_title \Документация
